export default __webpack_public_path__ + "static/media/mygeotab.e2c73dbd.svg";